import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Login/login';
import { css } from '@patternfly/react-styles';
export var LoginFooter = function LoginFooter(_a) {
  var _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$children = _a.children,
      children = _a$children === void 0 ? null : _a$children,
      props = __rest(_a, ["className", "children"]);

  return React.createElement("footer", Object.assign({
    className: css(styles.loginFooter, className)
  }, props), children);
};